module.exports = __webpack_public_path__ + "img/calendar.28dd58be.svg";